import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SupportIcon = ({ color })=>/*#__PURE__*/ _jsxs("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_595_3573)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M3.375 13.5H2.8125C2.21576 13.5 1.64347 13.2629 1.22151 12.841C0.799553 12.419 0.5625 11.8467 0.5625 11.25V9C0.5625 8.4033 0.799553 7.83098 1.22151 7.40901C1.64347 6.98705 2.21576 6.75 2.8125 6.75H3.375C3.52418 6.75 3.66726 6.80927 3.77275 6.91475C3.87824 7.02024 3.9375 7.16332 3.9375 7.3125V12.9375C3.9375 13.0867 3.87824 13.2298 3.77275 13.3352C3.66726 13.4408 3.52418 13.5 3.375 13.5Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M15.1875 13.5H14.625C14.4758 13.5 14.3327 13.4408 14.2273 13.3352C14.1217 13.2298 14.0625 13.0867 14.0625 12.9375V7.3125C14.0625 7.16332 14.1217 7.02024 14.2273 6.91475C14.3327 6.80927 14.4758 6.75 14.625 6.75H15.1875C15.7842 6.75 16.3565 6.98705 16.7785 7.40901C17.2004 7.83098 17.4375 8.4033 17.4375 9V11.25C17.4375 11.8467 17.2004 12.419 16.7785 12.841C16.3565 13.2629 15.7842 13.5 15.1875 13.5Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M2.8125 6.75C2.8125 5.10897 3.46439 3.53515 4.62478 2.37478C5.78515 1.21439 7.35897 0.5625 9 0.5625C10.641 0.5625 12.2149 1.21439 13.3752 2.37478C14.5356 3.53515 15.1875 5.10897 15.1875 6.75",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M11.25 16.3125H12.9375C13.5342 16.3125 14.1065 16.0754 14.5285 15.6535C14.9504 15.2315 15.1875 14.6592 15.1875 14.0625V13.5",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M10.125 17.4375H9C8.70165 17.4375 8.41545 17.319 8.20447 17.108C7.9935 16.897 7.875 16.6108 7.875 16.3125C7.875 16.0142 7.9935 15.728 8.20447 15.517C8.41545 15.306 8.70165 15.1875 9 15.1875H10.125C10.4233 15.1875 10.7096 15.306 10.9205 15.517C11.1315 15.728 11.25 16.0142 11.25 16.3125C11.25 16.6108 11.1315 16.897 10.9205 17.108C10.7096 17.319 10.4233 17.4375 10.125 17.4375Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M6.75 6.18756C6.75008 5.77508 6.86354 5.37056 7.07799 5.01821C7.29244 4.66586 7.5996 4.37924 7.96597 4.18967C8.33227 4.00011 8.74372 3.91489 9.15517 3.94335C9.5667 3.9718 9.96247 4.11282 10.2992 4.351C10.636 4.58917 10.9008 4.91534 11.0647 5.29385C11.2286 5.67236 11.2853 6.08865 11.2286 6.49721C11.1719 6.90577 11.0041 7.2909 10.7433 7.6105C10.4825 7.93008 10.1389 8.1718 9.75 8.30928C9.53055 8.3869 9.34057 8.5306 9.20625 8.72065C9.07192 8.91078 8.99985 9.1378 9 9.37053V9.56253",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M9 12.375C8.84467 12.375 8.71875 12.2491 8.71875 12.0938C8.71875 11.9384 8.84467 11.8125 9 11.8125",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M9 12.375C9.15533 12.375 9.28125 12.2491 9.28125 12.0938C9.28125 11.9384 9.15533 11.8125 9 11.8125",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_595_3573",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "18",
                        height: "18",
                        fill: "white"
                    })
                })
            })
        ]
    });
